import { getCurrentInstance } from 'vue'
import axios from '@axios'
import moment from 'moment'
import { localize } from 'vee-validate'
import flatpickr from 'flatpickr'
import { French as FlatPickrFrench } from 'flatpickr/dist/l10n/fr'
import { english as FlatPickrEnglish } from 'flatpickr/dist/l10n/default'

/**
 * Returns translated string if i18n package is available to Vue
 * If i18n is not configured then it will simply return what is being passed
 * Useful if you don't know if i18n is configured or not
 * Used in @core files to handle absence of i18n without errors
 * @param {String} key i18n key to use for translation
 */
export const t = key => {
  const vm = getCurrentInstance().proxy
  return vm.$t ? vm.$t(key) : key
}

export const _ = null

function setLangHeader(lang) {
  axios.defaults.headers['accept-language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  moment.locale(lang)
  localize(lang)

  if (lang === 'fr') {
    flatpickr.localize(FlatPickrFrench)
  } else {
    flatpickr.localize(FlatPickrEnglish)
  }
}

export const saveLang = lang => {
  localStorage.setItem('onclock-locale', lang)
  setLangHeader(lang)
}

export const loadLang = () => {
  const lang = localStorage.getItem('onclock-locale')
  setLangHeader(lang || 'en')

  return lang
}
